import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { INDUSTRY_ROLES_ENDPOINT } from './endpoints';

const actions = createActions({
  INDUSTRIES: {
    GET_ROLES: (industryId) => ({ industryId }),
    API: {
      GET_ROLES: apiResourceActionCreator('industryRoles')
    }
  }
})

export const apiAction = (industryId) => commonApiActions.get(INDUSTRY_ROLES_ENDPOINT(industryId), actions.industries.api.getRoles)

export function* fetchIndustryRoles(action) {
  yield put(apiAction(action.payload.industryId));
}

const configuration = {
  name: 'getRoles',
  action: actions,
  sagas: fetchIndustryRoles,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        industryRolesIsFetching: true,
        industryRoles: []
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        industryRolesIsFetching: false,
        industryRoles: action.payload.industryRoles
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        industryRolesIsFetching: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/roles.js